<script setup>
  const { data } = defineProps(['data']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap>
    <WrapCenter>
      <ShowAnimation fadeOnly><TextCta :data="data" /></ShowAnimation>
    </WrapCenter>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped></style>
